import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { PageHeader } from 'components/Header'
import { useTrackReport } from 'features/yieldbirdWrapperAgent/hooks/useTrackReport'
import { GenerateReportSection } from 'features/yieldbirdWrapperAgent/sections/GenerateReportSection'
import { ReportsSection } from 'features/yieldbirdWrapperAgent/sections/ReportsSection'
import { TrackedReportSection } from 'features/yieldbirdWrapperAgent/sections/TrackedReportSection'

import type { TrackedReport } from 'features/yieldbirdWrapperAgent/types'

export const YieldbirdWrapperAgentPage = (): React.JSX.Element => {
  const { t } = useTranslation('features/yieldbirdWrapperAgent')
  const [trackedReport, setTrackedReport] = useState<TrackedReport>()
  const { isProcessing, isStalled, isTracking, reportStatus } = useTrackReport(trackedReport?.jobId)

  return (
    <>
      <PageHeader
        description={{ text: t('description') }}
        title={t('title')}
      />

      <GenerateReportSection
        disabled={isProcessing}
        onCreated={setTrackedReport}
      />

      {trackedReport && (
        <TrackedReportSection
          isStalled={isStalled}
          isTracking={isTracking}
          report={trackedReport}
          reportStatus={reportStatus}
        />
      )}

      <ReportsSection />
    </>
  )
}
